import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=7a9f652c&lang=html&"
import script from "./LogoutPage.vue?vue&type=script&lang=js&"
export * from "./LogoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a9f652c')) {
      api.createRecord('7a9f652c', component.options)
    } else {
      api.reload('7a9f652c', component.options)
    }
    module.hot.accept("./LogoutPage.vue?vue&type=template&id=7a9f652c&lang=html&", function () {
      api.rerender('7a9f652c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/LogoutPage.vue"
export default component.exports